import { Box, Button, Container } from '@mui/material';
import HeaderBreadcrumbs from 'src/components/header-bread-crumbs/HeaderBreadcrumbs';
import Page from 'src/components/page/page';
import CNLoading from 'src/components/loading-cn/CNLoading';
import TableRox from 'src/components/table-rox/TableRox';
import { paths } from 'src/routes/paths';
import useFairList from './fair-list.hook';

export default function FairList() {
  const { 
    TABLEHEADER, 
    loadingFairList, 
    fairList, 
    navigate,
  } = useFairList();

  return (
    <Page title="Lista de Feiras Expo">
      <Container maxWidth="lg">
        <HeaderBreadcrumbs
          heading="Lista de Feiras Expo"
          links={[]}
          action={
            <Button variant="contained" onClick={() => navigate(paths.dashboard.fairCreate)}>
              Cadastrar Feira
            </Button>
          }
        />
        {loadingFairList ? (
          <Box flexGrow={1} display="flex" justifyContent="center" alignItems="center" mt={30}>
            <CNLoading />
          </Box>
        ) : (
          <TableRox
            data={fairList}
            header={TABLEHEADER}
            defaultOrderBy="name"
            hasSearch
            onClickKey="_id"
            onClickFunction={(id) => navigate(paths.dashboard.fairDetails(id))}
          />
        )}
      </Container>
    </Page>
  );
}
